

























































































import { mapActions } from 'vuex';

import Vue from 'vue';
import { BAlert, BTabs, BTab, BRow, BCol, BFormRadioGroup } from 'bootstrap-vue';

import { ZenFormGroup } from 'zenComponents';
import LoadingSpinner from '@reciprocity/loading-spinner';
import ZenButton from '@reciprocity/button';
import { Factor, Vector } from '@/pages/risk_settings/types';
import { keysToSnake, keysToCamel } from '@/utils';
import { getRequest, postRequest } from '../../utils/client/client';

interface Endpoints {
  getElements: string;
  getFactors: string;
  postFactor: string;
  getScores: string;
  postScore: string;
}

export default Vue.extend({
  name: 'RiskScoringTab',
  components: {
    BAlert,
    BRow,
    BCol,
    BTab,
    BTabs,
    ZenFormGroup,
    BFormRadioGroup,
    LoadingSpinner,
    ZenButton,
  },
  props: {
    endpoints: {
      type: Object as () => Endpoints,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    csrf: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeScore: 0,
      scores: [],
      factors: <Factor[]>[],
      vectors: <Vector[]>[],
      scoresLoading: true,
      elementsLoading: true,
      factorsLoading: true,
      savingScore: false,
      factorChanged: false,
    };
  },
  computed: {
    allFactorsSelected(): boolean {
      return this.factors.every(item => item.selectedId !== null);
    },
  },
  async created() {
    try {
      var data = await getRequest({ url: this.endpoints.riskScoringTabScores });
      this.scores = keysToCamel(data);
      this.scoresLoading = false;
      this.getElements();
    } catch (error) {
      window.GGRC.Notify({
        type: 'error',
        message: 'Oops, something went wrong.',
      });
    }
  },
  methods: {
    ...mapActions({
      showModal: 'modals/show',
    }),
    getSelectedFactorOption(factor: Factor): Factor {
      return factor.options.find(opt => opt.id === factor.selectedId);
    },
    getSelectedOptionValue(factor: Factor): number | string | null {
      const opt = this.getSelectedFactorOption(factor);
      return opt ? opt.value : null;
    },
    changeScore(index: number) {
      this.activeScore = index;
      this.getElements();
      this.factorChanged = false;
    },
    async getElements() {
      if (!this.scores.length || this.activeScore < 0) {
        return;
      }
      this.elementsLoading = true;
      this.unscoredNestedScores = [];

      try {
        const url = this.endpoints.riskScoringTabElements.replace('__SCORE_ID__', this.scores[this.activeScore].id);
        const data = await getRequest({ url });
        const elements = keysToCamel(data);
        this.factors = elements['factors'];
        this.vectors = elements['vectors'];
        this.nestedScores = elements['nestedScores'];
        this.unscoredNestedScores = this.nestedScores
          .filter(function(nestedScore) {
            return nestedScore.calculated == null;
          })
          .map(nestedScore => nestedScore.title);
        this.elementsLoading = false;
      } catch (error) {
        window.GGRC.Notify({
          type: 'error',
          message: 'Oops, something went wrong.',
        });
      }
    },
    async calculate() {
      this.savingScore = true;

      try {
        const url = this.endpoints.calculateScore.replace('__SCORE_ID__', this.scores[this.activeScore].id);
        const data = await postRequest({
          url,
          data: JSON.stringify(keysToSnake({ selectedOptions: this.prepareSelectedFactorOptionsData() })),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.csrf,
          },
        });
        const calculationData = keysToCamel(data);
        this.scores[this.activeScore] = calculationData['score'];
        this.vectors = calculationData['vectors'];
        this.factorChanged = false;
        if (calculationData.modal) {
          window.GGRC.zenModal.show(calculationData.modal);
        }
      } catch (error) {
        window.GGRC.Notify({
          type: 'error',
          message: error.response.data.message,
        });
      } finally {
        this.savingScore = false;
      }
    },
    factorChange() {
      this.factorChanged = true;
    },
    prepareSelectedFactorOptionsData() {
      return this.factors.map(factor => {
        return {
          factorOptionId: factor.selectedId,
        };
      });
    },
  },
});
